import React from 'react'
import styled, { css } from 'styled-components'
import {
  color,
  borderRadius,
  boxShadow,
  boxShadowActive,
  bp
} from '../globalStyles'
import { Link } from 'react-router-dom'

const mixin = {
  textAlign: css`
    ${props => {
    if (props.taLeft) return 'text-align: left;'
    if (props.taCenter) return 'text-align: center;'
    if (props.taRight) return 'text-align: right;'
  }};
  `,
  position: css`
    ${props => {
    if (props.relative) return 'position: relative;'
    if (props.absolute) return 'position: absolute;'
  }};
  `,
  color: css`
    ${props => {
    if (props.light) return `background: ${color.lightGrey};`
  }};
  `
}

export const Absolute = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  `

export const Relative = styled.div`
  ${mixin.color};
  position: relative;
  z-index: 0;
  `

export const Page = styled.div`
  ${mixin.color};
  width: 100%;
  min-height: 100%;
  ${props => props.bgWhite && 'background-color: white'};
  `

export const Section = styled.section`
  ${mixin.position}
  ${mixin.textAlign}
  width: 100%;
  padding: ${props => {
    if (props.thick) return '10rem 0'
    if (props.thin) return '2.5rem 0'
    return '5rem 0'
  }};
  ${props => (props.pt0 ? 'padding-top: 0;' : '')}
  ${props => (props.pb0 ? 'padding-bottom: 0;' : '')}
  background: ${props => props.bg || 'transparent'};
  border-bottom: ${props => (props.borderBottom ? '1px solid whitesmoke' : '')};
  `

export const Container = styled.div`
  ${mixin.position}
  ${mixin.textAlign}
  max-width: ${props => (props.skinny ? '600px' : '1111px')};
  ${props => (props.noMax || props.desktopOnly) && 'max-width: 150rem'};
  ${props => !props.desktopOnly && 'width: 90%'};
  margin: 0 auto;

  @media (${bp.desktop}) {
    ${props => props.desktopOnly && 'width: 90%'};
    max-width: ${props => (props.skinny ? '600px' : '840px')};
    ${props => props.noMax && 'max-width: 150rem'};

  }
  `

export const Flex = styled.div`
  display: flex;
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  justify-content: ${props => {
    if (props.justifyCenter) return 'center'
    if (props.justifyEnd) return 'flex-end'
    if (props.justifyBetween) return 'space-between'
    if (props.justifyAround) return 'space-around'
    return 'flex-start'
  }};
  align-items: ${props => {
    if (props.alignStart) return 'flex-start'
    if (props.alignEnd) return 'flex-end'
    if (props.alignStretch) return 'stretch'
    return 'center'
  }};
  height: ${props => (props.grow ? '100%' : 'auto')};
  width: ${props => (props.grow ? '100%' : 'auto')};
  `

const ButtonStyles = css`
  appearance: none;
  border: none;
  font-weight: 600;
  padding: 1rem 1.5rem;
  text-decoration: none;
  font-size: 1.6rem;
  display: inline-block;
  background: ${props =>
    props.isPrimary ? color.primary : color.primaryLight};
  color: ${props => (props.isPrimary ? 'white' : color.primary)};
  border-radius: ${borderRadius};
  box-shadow: ${props => (props.shadow ? boxShadow : 'none')};
  cursor: pointer;
  transition: all 0.15s ease;

  &:focus,
  &:hover,
  &.active {
    outline: none;
    ${props =>
    props.shadow &&
      `
      box-shadow: ${boxShadowActive};
      transform: translateY(-1px);
      opacity: 0.8;
        `};
  }
  `

export const Button = styled(({ isPrimary, rounded, shadow, ...props }) => {
  if (props.to || props.href) return <Link {...props} />
  return <button {...props} />
})`
  ${ButtonStyles};
  `

export const ButtonInput = styled.input`
  ${ButtonStyles};
  `

export const Loading = styled.div`
  background: salmon;
  `



// WEBPACK FOOTER //
// ./src/components/common.js